import { useIsMobile } from "./useIsMobile";

export const useGetStyles = () => {
  const isMobile = useIsMobile();

  return {
    fontVerySmall: isMobile ? "text-[.65rem]" : "text-xs",
    fontSmall: isMobile ? "text-[1.0rem]" : "text-s",
    fontMedium: isMobile ? "text-[1.5rem]" : "text-base",
    fontLarge: isMobile ? "text-[2.5rem]" : "text-lg",
    fontVeryLarge: isMobile ? "text-[6rem]" : "text-xl",
  };
};
